<template>

    <img :src="headerImage" class="page-header" alt="Header" />

</template>

<script>
export default {
  name: "CompanyInfo",
  computed: {
    headerImage() {
      const companyId = this.$session.get("companyId");
      const extensions = ["png", "jpg", "jpeg"]; // image formats to check

      for (const ext of extensions) {
        try {
          return require(`@/assets/images/company${companyId}/header.${ext}`);
        } catch (e) {
          // try next extension
        }
      }

      // No header image found → return null
      return null;
    }
  }
};
</script>
